var _path, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconQuestionmark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.738 13.68c-.618 0-1.08-.463-1.08-1.061 0-.656.443-1.12 1.08-1.12.637-.02 1.12.464 1.12 1.1 0 .618-.463 1.082-1.12 1.082zm2.394-5.038c-.27.231-.54.444-.83.637-.425.29-.676.734-.676 1.313H7.89c-.077-.618-.039-1.313.521-1.757.328-.251.676-.464.946-.734.251-.27.502-.598.618-.927.135-.424-.193-.926-.56-1.061-.54-.194-1.197-.04-1.429.405-.135.25-.212.56-.328.869H6.035c-.173-.869.31-1.93 1.12-2.452 1.12-.695 3.031-.54 4.016.347.985.87.965 2.49-.039 3.36z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 8,
    stroke: "currentColor",
    strokeWidth: 2,
    fill: "none"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQuestionmark);
export default __webpack_public_path__ + "static/media/icon-questionmark.7526d30a324f8a667f9c5428e4627fe7.svg";
export { ForwardRef as ReactComponent };